import moment from 'moment';
import 'moment/locale/ko';

import { ko } from 'date-fns/locale';
import parseISO from 'date-fns/parseISO';
import intervalToDuration from 'date-fns/intervalToDuration';

import { format as fnsFormat } from 'date-fns';

const { APP_ENV } = process.env;

const __PROD__ = APP_ENV === 'production';

const getMoment = (datetime) => moment(datetime).locale('ko');

const dateStringToDate = (dateStr) =>
  typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;

const formatDate = (dirtyDate, format = 'yyyy-MM-dd') => {
  const datetime = dateStringToDate(dirtyDate);
  return fnsFormat(datetime, format, { locale: ko });
};

const getTimeDiff = (datetime, unit = 'minutes') =>
  moment().diff(moment(dateStringToDate(datetime)), unit);

const getTimeFromNow = (dirtyDate, noSuffix = false) => {
  const datetime = dateStringToDate(dirtyDate);

  if (getTimeDiff(datetime) > 60 * 24 * 7) {
    return formatDate(datetime);
  }
  return getMoment(datetime).fromNow(noSuffix);
};

const formatSeconds = (seconds) => {
  const duration = moment.duration(seconds, 'seconds');
  const years = duration.years();
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  if (years || months || days) {
    return `${Math.floor(duration.asDays())}일${hours ? ` ${hours}시간` : ''}`;
  }

  return `${hours ? `${hours}시간 ` : ''}${minutes ? `${minutes}분` : ''}`;
};

const formatSecondsToTimer = (_seconds, hideHours = false) => {
  const duration = moment.duration(_seconds, 'seconds');
  const hours =
    duration.hours() >= 10
      ? Math.floor(duration.hours())
      : `0${Math.floor(duration.hours())}`;
  const minutes =
    duration.minutes() >= 10 ? duration.minutes() : `0${duration.minutes()}`;
  const seconds =
    duration.seconds() >= 10 ? duration.seconds() : `0${duration.seconds()}`;

  if (hideHours) {
    return `${minutes ? `${minutes}` : '00'}:${seconds ? `${seconds}` : '00'}`;
  }

  return `${hours ? `${hours}` : '00'}:${minutes ? `${minutes}` : '00'}:${
    seconds ? `${seconds}` : '00'
  }`;
};

const secondsToDuration = (seconds, simplify = false) => {
  const duration = intervalToDuration({ start: 0, end: seconds * 1000 });
  if (!simplify) {
    const text = [];
    if (duration.days) {
      text.push(`${duration.days}일`);
    }
    if (duration.hours) {
      text.push(`${duration.hours}시간`);
    }
    if (duration.minutes) {
      text.push(`${duration.minutes}분`);
    }
    if (duration.seconds) {
      text.push(`${duration.seconds}초`);
    }
    return text.join(' ');
  }

  if (duration.days) {
    return `${duration.days}일`;
  }
  if (duration.hours) {
    return `${duration.hours}시간`;
  }
  if (duration.minutes) {
    return `${duration.minutes}분`;
  }
  if (duration.seconds) {
    return `${duration.seconds}초`;
  }
};

const checkPeriod = (
  startDate,
  endDate,
  startHours = null,
  endHours = null
) => {
  const now = new Date();
  const nowToInt = parseInt(formatDate(now, 'yyyyMMdd'), 10);
  if (startHours) {
    if (nowToInt === startDate) {
      return now.getHours() >= startHours;
    } else {
      return nowToInt >= startDate + 1 && nowToInt <= endDate;
    }
  }

  if (endHours && nowToInt === endDate) {
    return now.getHours() < endHours;
  }

  return __PROD__
    ? nowToInt >= startDate && nowToInt <= endDate
    : nowToInt <= endDate;
};

export default {
  getMoment,
  formatDate,
  getTimeDiff,
  getTimeFromNow,
  formatSeconds,
  formatSecondsToTimer,
  secondsToDuration,
  checkPeriod,
};



// WEBPACK FOOTER //
// ./src/app/utils/datetime.js